const mantenimiento = false;

module.exports = mantenimiento